<template>
    <div class="w-full mx-auto px-2 md:px-4 lg:px-8 py-2">
        <Remove v-if="removeModal" @changeVisibility="removeModal = false" @remove="remove()"/>
        <Adicionar :loja="loja" v-if="addModal"/>
        <div class="w-full flex flex-row-reverse mt-4">
            <button v-if="!addModal" @click="addModal = true" class="btn py-2 px-4 bg-indigo-500 rounded-lg text-gray-100 uppercase text-sm">+ Adicionar</button>
            <button v-else @click="addModal = false; getProducts()" class="btn py-2 px-4 bg-indigo-500 rounded-lg text-gray-100 uppercase text-sm">Concluir</button>
        </div>
        <div v-if="!addModal" class="flex flex-row gap-x-4 w-full">
            <div class="pt-2 w-1/4 flex-none h-40 sticky rounded-lg">
                <div class="w-4/5 m-auto py-4 flex flex-col gap-y-4">
                    <p class="text-2xl dark:text-gray-300 text-gray-700">Filtros</p>
                    <span class="w-full md:flex-1">
                        <Autocomplete v-model="marca" label="Marca" placeholder="Selecionar marca" :list="marcas" desc="marca" @filter="filterByMarca()"/>
                    </span>
                    <span class="w-full md:flex-1">
                        <Autocomplete v-model="modelo" label="Modelo" placeholder="Selecionar modelo" :list="modelos" desc="descricao" @filter="filterByModelo()"/>
                    </span>

                    <span class="w-full md:flex-1">
                        <p class="uppercase text-gray-300 text-xs"> </p>
                        <Input v-model="searchComplemento" label="Pesquisar complemento"/>
                    </span>
                </div>
            </div>
            <div id="lojas-section" class="w-3/4 flex-none flex flex-col flex-wrap gap-y-4 mt-2 overflow-y-scroll">
                <div v-if="listProducts.length === 0 || filteredListProducts.length === 0" class="dark:text-gray-400 text-gray-500 dark:bg-gray-800 bg-gray-200 w-full h-24 rounded-lg flex flex-col items-center justify-center py-2 px-5">
                    <p class="text-lg">Nenhum resultado encontrado para essa pesquisa</p>
                </div>
                <span v-for="c, i in filteredListProducts" :key="i" class="w-full">
                    <div class="dark:bg-gray-800 bg-gray-100 border border-gray-200 dark:border-gray-700 h-24 rounded-lg shadow-lg flex items-center px-4 gap-x-4">
                        <p class="text-base text-indigo-500">#{{c.complemento_id}}</p>
                        <span class="w-full">
                            <p class="text-gray-700 dark:text-gray-300 text-base">{{c.marca}} {{c.modelo_descricao}}</p>
                            <p class="text-gray-700 dark:text-indigo-200 text-xl">{{c.complemento}}</p>
                        </span>
                        <div class="">
                            <button class="btn text-indigo-500 text-sm uppercase" @click="openRemoveModal(c.marca_id, c.modelo_id, c.complemento_id)">Remover</button>
                        </div>

                    </div>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import Input from '@/components/Design/Input'
import Autocomplete from '@/components/Design/Autocomplete'
import Select from '@/components/Design/Select'
import { GET_MODELOS_BY_MARCA, GET_MARCAS_BY_SEGMENTO, GET_COMPLEMENTOS_BY_MODELO, GET_PRODUTOS_BY_LOJA, GET_LOJAS_ATIVAS, GET_LOJA_ATIVA_BY_ID, DELETE_PRODUTOS_LOJA } from '../../mixins/api.js'
import { computed, onMounted, ref } from 'vue'
import useVuelidate from '@vuelidate/core'
import { findId } from '../../mixins/findData.js'
import { useRoute } from 'vue-router'
import { displayNotification } from '../../mixins/notification.js'
import Remove from '../Pesquisa/ModalRemove.vue'
import Adicionar from './AdicionarProduto.vue'
export default {
    name: 'ListaProdutos',
    components: {
        Input,
        Select,
        Autocomplete,
        Remove,
        Adicionar
    },
    setup () {
        const segmentos = ref([])
        const segmento = ref('')
        const marcas = ref([])
        const marca = ref('')
        const modelos = ref([])
        const modelo = ref('')
        const complementos = ref('')
        const complemento = ref('')
        const searchComplemento = ref('')

        const listProducts = ref([])
        const listProductsCopy = ref([])

        const route = useRoute()

        const filterByMarca = async () => {
            if (marca.value === '') {
                modelo.value = ''
                listProducts.value = listProductsCopy.value
            } else {
                const id = findId(marcas.value, marca.value, 'marca')
                await GET_MODELOS_BY_MARCA(id).then(r => {
                    modelos.value = r.data
                })
                listProducts.value = listProducts.value.filter(x => x.marca.toLowerCase() === marca.value.toLowerCase())
            }
        }

        const filterByModelo = async () => {
            if (modelo.value === '') {
                listProducts.value = listProductsCopy.value.filter(x => x.marca.toLowerCase() === marca.value.toLowerCase())
            } else {
                const id = findId(modelos.value, modelo.value, 'descricao')
                await GET_COMPLEMENTOS_BY_MODELO(id).then(r => {
                    complementos.value = r.data
                })
                listProducts.value = listProducts.value.filter(x => x.modelo_descricao === modelo.value)
            }
        }

        const filteredListProducts = computed(() => {
            if (searchComplemento.value === '') {
                return listProducts.value
            }
            if (listProducts.value.length === 0) { return listProducts.value }
            return listProducts.value.filter(x => x.complemento.toLowerCase().includes(searchComplemento.value.toLowerCase()))
        })

        const getProducts = async () => {
            await GET_PRODUTOS_BY_LOJA(route.params.id).then(r => {
                listProducts.value = r.data
                listProductsCopy.value = listProducts.value
            })
        }
        const loja = ref({})
        onMounted(async () => {
            await GET_LOJA_ATIVA_BY_ID(route.params.id).then(r => {
                loja.value = r.data.data
            })

            await GET_MARCAS_BY_SEGMENTO(loja.value.segmento_id).then(r => {
                marcas.value = r.data
            })
            await getProducts()
        })

        const rules = computed(() => {
            return {
                segmento:
                    { uincludes: (value) => segmentos.value.map(a => a.descricao).includes(value.value) }

            }
        })
        const v$ = useVuelidate(rules, { segmento })

        const removeModal = ref(false)
        const productToRemove = ref({})
        const openRemoveModal = (marca_id, modelo_id, complemento_id) => {
            
            productToRemove.value.marca_id = marca_id
            productToRemove.value.modelo_id = modelo_id
            productToRemove.value.complemento_id = complemento_id
            removeModal.value = true
        }

        const remove = async () => {
            
            await removeProduct(productToRemove.value.marca_id, productToRemove.value.modelo_id, productToRemove.value.complemento_id)
            removeModal.value = false
        }

        const removeProduct = async (marca_id, modelo_id, complemento_id) => {
            await DELETE_PRODUTOS_LOJA(loja.value.id, { marca_id, modelo_id, complemento_id }).then(r => {
                displayNotification(r)
                getProducts()
            }).catch(e => {
                displayNotification(e.response)
            })
        }

        const addModal = ref(false)

        return {
            segmentos,
            segmento,
            marcas,
            marca,
            modelos,
            modelo,
            complemento,
            complementos,
            searchComplemento,
            filteredListProducts,
            v$,
            filterByMarca,
            filterByModelo,
            listProducts,
            loja,
            openRemoveModal,
            remove,
            removeProduct,
            removeModal,
            addModal,
            getProducts

        }
    }
}
</script>
<style>
</style>
